import { useEffect, useState } from "react"
import ReactMarkdown, { Components } from "react-markdown"
import remarkGfm from "remark-gfm"
import { Link } from "react-router-dom"
import { getManualAssetUrl } from "slices/manuals/thunk"

const IMAGES_PREFIX = "_images/"

// Screenshots live behind the API (auth cookie), so they are fetched as blobs.
const ManualImage = ({ src, alt }: { src?: string, alt?: string }) => {
    const [url, setUrl] = useState<string | null>(null)

    useEffect(() => {
        if (!src) return
        if (!src.startsWith(IMAGES_PREFIX)) {
            setUrl(src)
            return
        }
        let objectUrl: string | null = null
        let cancelled = false
        getManualAssetUrl(src.slice(IMAGES_PREFIX.length)).then(u => {
            objectUrl = u
            if (!cancelled) setUrl(u)
        })
        return () => {
            cancelled = true
            if (objectUrl) URL.revokeObjectURL(objectUrl)
        }
    }, [src])

    if (!url) return <span className="markdown-viewer__img-placeholder">{alt}</span>
    return <img src={url} alt={alt ?? ""} className="markdown-viewer__img" />
}

const components: Components = {
    img: ({ src, alt }) => <ManualImage src={typeof src === "string" ? src : undefined} alt={alt} />,
    a: ({ href, children }) =>
        href?.startsWith("/")
            ? <Link to={href}>{children}</Link>
            : <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>,
    table: ({ children }) => (
        <div className="table-responsive">
            <table className="table table-bordered table-sm">{children}</table>
        </div>
    ),
}

interface MarkdownViewerProps {
    content: string
}

// Raw HTML in markdown is not rendered (react-markdown default), so content is safe to display.
const MarkdownViewer = ({ content }: MarkdownViewerProps) => (
    <div className="markdown-viewer">
        <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
            {content}
        </ReactMarkdown>
    </div>
)

export default MarkdownViewer
